import { BotonExportarExcel, Card, DesktopOnly, Group, Table, Tbody, Th, Thead, Tr } from "@/components/ui";
import type { ProveedorAdmin } from "@/lib/types";
import { ProveedorRow } from "./ProveedorRow";

export function ProveedoresDesktopTable({
  items,
  obtenerFilas,
}: {
  items: ProveedorAdmin[];
  /** Trae TODAS las páginas con los filtros actuales · para el export. */
  obtenerFilas: () => Promise<ProveedorAdmin[]>;
}) {
  return (
    <DesktopOnly>
      <Card padding="lg">
        <Group justify="flex-end" className="mb-2">
          <BotonExportarExcel
            archivo="proveedores"
            hoja="Proveedores"
            obtenerFilas={obtenerFilas}
            columnas={[
              { header: "Núm. proveedor", value: (p) => p.numeroProveedor },
              { header: "RFC", value: (p) => p.rfc },
              { header: "Razón social", value: (p) => p.razonSocial },
              { header: "Banco", value: (p) => p.datosBancarios.banco },
              { header: "Cuenta", value: (p) => p.datosBancarios.cuenta },
              { header: "CLABE", value: (p) => p.datosBancarios.clabe },
              { header: "Estado", value: (p) => (p.estaActivo ? "Activo" : "Inactivo") },
            ]}
          />
        </Group>
        <div className="overflow-x-auto">
          <Table verticalSpacing="sm">
            <Thead>
              <Tr>
                <Th># Prov</Th>
                <Th>RFC</Th>
                <Th>Razón social</Th>
                <Th>Banco</Th>
                <Th>Cuenta</Th>
                <Th>Estado</Th>
                <Th />
              </Tr>
            </Thead>
            <Tbody>
              {items.map((p) => (
                <ProveedorRow key={p.numeroProveedor} prov={p} />
              ))}
            </Tbody>
          </Table>
        </div>
      </Card>
    </DesktopOnly>
  );
}
